import { z } from 'zod';
import { DepartmentSchema } from '../../entities/department/department.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Update Department Request Schema
 * PATCH /api/v2/departments/:id
 */ export const UpdateDepartmentRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    description: z.string().optional(),
    abbreviation: z.string().optional(),
    manager: z.string().optional(),
    parent: z.string().optional()
});
/**
 * Update Department Response Schema
 * PATCH /api/v2/departments/:id
 */ export const UpdateDepartmentResponseSchema = z.object({
    data: DepartmentSchema
});

//# sourceMappingURL=update-department.schema.js.map